
import React, { createContext, useState, useEffect, useContext } from 'react';

type TranscriptionMode = 'cloud' | 'local';

interface TranscriptionModeContextType {
  mode: TranscriptionMode;
  isLocal: boolean;
  toggleMode: () => void;
}

const TranscriptionModeContext = createContext<TranscriptionModeContextType | undefined>(undefined);

export const TranscriptionModeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [mode, setMode] = useState<TranscriptionMode>('cloud');

  useEffect(() => {
    const stored = localStorage.getItem('transcription-mode') as TranscriptionMode | null;
    if (stored === 'cloud' || stored === 'local') {
      setMode(stored);
    }
  }, []);

  const toggleMode = () => {
    setMode(prev => {
      const next = prev === 'cloud' ? 'local' : 'cloud';
      localStorage.setItem('transcription-mode', next);
      return next;
    });
  };

  return (
    <TranscriptionModeContext.Provider value={{ mode, isLocal: mode === 'local', toggleMode }}>
      {children}
    </TranscriptionModeContext.Provider>
  );
};

export const useTranscriptionMode = (): TranscriptionModeContextType => {
  const context = useContext(TranscriptionModeContext);
  if (!context) {
    throw new Error('useTranscriptionMode must be used within a TranscriptionModeProvider');
  }
  return context;
};
